import React from "react";
import { Box } from "@chakra-ui/react";
import DesktopTabs from "./DesktopTabs";
import MobileTopBar from "./MobileTopBar";

export default function TopBar() {
  return (
    <Box as="nav" aria-label="Հիմնական նավարկում">
      <DesktopTabs />
      <MobileTopBar />
    </Box>
  );
}
